export default __webpack_public_path__ + "static/media/chalet1.b56e0a19.jpg";